import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { 
	openModal
} from 'state/actions'

const RegisterRoute = ({
    openModal,
    userData
}) => {
    useEffect(() => {
        const hasUserAlready = userData && userData.lastOpenAccountSlug

        if(!hasUserAlready){
            openModal('register', 'register', {})
        }
    }, [])

    return (
        <div />
    )
}

const mapStateToProps = state => {
	return {
        
    }
}

export default connect(mapStateToProps, {
	openModal
})(RegisterRoute)


// WEBPACK FOOTER //
// ./src/components/auth/register-route.jsx